<template>
  <div id="stepFour">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
        <h2>Financial Assistance</h2>
        <p>Travel assistance may be provided based on the Student Volunteer Program's availability of funds and on eligibility, which is determined on a case-by-case basis based solely on financial need. Assistance goes through a blind jury process. It is not based on nationality or country/location of residence, anyone can apply and everyone will be considered equally. Funds are limited and assistance is not guaranteed. Travel assistance, if awarded, will be communicated upon acceptance.</p>
        <b-form-group>
          <b-form-checkbox id="financialAid" v-model="financialAid">
            I would like to apply for financial assistance
          </b-form-checkbox>
        </b-form-group>
        <b-form-group v-if="financialAid">
          <div class="row">
            <div class="col col-md-8">
              <h6>We understand that attending SIGGRAPH can be a considerable financial investment. Please share with us why financial assistance would be important for you to participate</h6>
              <b-form-textarea id="financialAidSummary" @input="wordCount('financialAidSummary', 100)" v-model="financialAidSummary" :rows="6" :max-rows="100"/>
              <p :class="financialAidSummaryWordLimitClass">{{ financialAidSummaryWordCount }}</p>
            </div>
          </div>
          <b-form-group
              label="Please select any situations that apply to your request for financial assistance:"">
              <multiselect :options="financialSituationOptions" :value="getFinancialSituation" :searchable="false" :multiple="true"
                :close-on-select="false" track-by="value" label="text" :allow-empty="true" :hide-selected="true" @input="updateFinancialSituation">
                <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span
                      class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
              </multiselect>
            </b-form-group>
          <!-- <label style="margin-bottom: 0px" for="financialSituation">Please select any situations that apply to your request for financial assistance:</label> -->
          <!-- <b-form-group>
            <b-form-checkbox-group
              v-model="financialSituation"
              :options="financialSituationOptions"
              name="financialSituation"
              stacked
            />
          </b-form-group> -->
        </b-form-group>
        <b-form-group v-if="financialAid">
          <div class="row">
            <div class="col col-md-8">
              <h6>Please provide an itemized breakdown of your anticipated travel expenses in US dollars (Typically assistance would include provisions for things like travel, lodging, food, conference transport, etc).</h6>
              <b-form-textarea id="financialAidExpenses" v-model="financialAidExpenses" :rows="6" :max-rows="100"/>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAid">
          <div class="row">
            <div class="col col-md-8">
          <h6>Sum up your previous calculations into a total estimate in US dollars.</h6>
          <b-form-input type="text" v-model="estimatedTravelCost" id="estimatedTravelCost"></b-form-input>
          </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAid" label="Primary Mode of Transportation to the Conference's City" label-for="primaryTransport">
          <b-form-select id="primaryTransport" v-model="primaryTransport" :options="primaryTransportList"/>
        </b-form-group>
        <b-form-group v-if="financialAidAndFlying" label=" If you will be flying, what is the 3-letter code for the airport you will be departing from? (Ex: IND for Indianapolis International Airport)" label-for="airportCode">
          <div class="row">
            <div class="col-2">
              <b-form-input type="text" v-model="airportCode" id="airportCode"></b-form-input>
            </div>
          </div>
        </b-form-group>
        <b-form-group v-if="financialAidAndOtherTransport" label="Please explain how you are planning to travel to the conference" label-for="otherTransport">
              <b-form-input type="text" v-model="otherTransport" id="otherTransport"></b-form-input>
        </b-form-group>
        <b-form-group v-if="financialAid">
          <b-form-checkbox id="fundedTravel" v-model="fundedTravel">
            Funding for my travel will be fully or partially covered by outside sources (such as university funding, etc.).
          </b-form-checkbox>
        </b-form-group>
      <b-form-group>
        <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-sm float-sm-left" @click="previousStep"><div>Previous Step</div></button>
        <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-sm float-sm-right" @click="nextStep"><div>Save and Continue</div></button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { primaryTransportList, financialSituationOptions } from '@/util/SelectLists'
import { mapState, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import router from '@/router'
import moment from 'moment'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'AppStepFour',
  data () {
    return {
      primaryTransportList: primaryTransportList,
      financialSituationOptions: financialSituationOptions,
      financialAidSummaryWordCount: '100 words remaining',
      financialAidSummaryWordLimitClass: 'under-limit',
      disabled: false
    }
  },
  computed: {
    ...generateVuexSetters([
      'financialAidSummary',
      'primaryTransport',
      'airportCode',
      'otherTransport',
      'financialAidExpenses',
      'financialSituation',
      'estimatedTravelCost',
      'fundedTravel'
    ]),
    financialAid: {
      get () {
        return this.$store.state.application.financialAid
      },
      set (value) {
        this.$store.commit('application/updateFinancialAid', value)
      }
    },
    ...mapState('application', ['isLoaded', 'isLoading']),
    ...mapGetters('application', ['financialAidAndFlying', 'financialAidAndOtherTransport', 'getFinancialSituation']),
    ...mapGetters(['pastTLAppDeadline'])
  },
  methods: {
    wordCount (field, limit) {
      let words = this[field].trim().split(/\s+/)
      let wordCount = (words.length === 1 && words[0] === '') ? 0 : words.length
      let remaining = limit - wordCount
      this[field + 'WordCount'] = (remaining < 0) ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining'
      this[field + 'WordLimitClass'] = (remaining < 0) ? 'over-limit' : 'under-limit'
    },
    updateFinancialSituation (value) {
      this.$store.commit('application/updateField', { name: 'financialSituation', value: value })
    },
    nextStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 5)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepFive' })
          window.scrollTo(0, 0)
          this.disabled = true
        }).catch(err => {
          console.log(err.message)
          this.disabled = true
        })
      }
    },
    previousStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 3)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepThree' })
          this.disabled = false
        }).catch(err => {
          console.log(err.message)
          this.disabled = false
        })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.$store.dispatch('application/save')
        } else if (this.$store.state.application.step !== 3) {
          router.push('/application/' + this.$store.state.application.step.toString())
        }
      })
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  },
  mounted: function () {
    this.wordCount('financialAidSummary', 100)
  },
  components: {
    multiselect: Multiselect
  }
}
</script>

<style lang="scss">
@import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
</style>




// WEBPACK FOOTER //
// src/components/application/StepFour.vue